<template>
  <div>
    <vue-particles
      color="#dedede"
      :particleOpacity="0.1"
      :particlesNumber="20"
      shapeType="circle"
      :particleSize="15"
      linesColor="#dedede"
      :linesWidth="0"
      :lineLinked="false"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="1"
      :hoverEffect="true"
      hoverMode="push"
      :clickEffect="false"
      clickMode="push"
    >
    </vue-particles>

    <v-timeline :dense="mobileDetected ? true : false">
      <v-timeline-item
        v-for="{ name, date, link, imageName, linkIcon, info } in pageEvents"
        :key="name"
        color="black lighten-2"
        large
        icon="remove"
      >
        <span v-if="mobileDetected" :class="`headline font-weight-bold`">
          {{ date }}
        </span>

        <span
          v-if="!mobileDetected"
          slot="opposite"
          :class="`headline font-weight-bold`"
        >
          {{ date }}
        </span>

        <v-hover>
          <v-card
            dark
            flat
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-btn absolute bottom right fab>
              <v-icon v-on:click="goUrl($event, link)">{{ linkIcon }}</v-icon>
            </v-btn>
            <v-card-title
              :class="`pa-2 blue-grey darken-${hover ? 3 : 4}`"
              style="display: block"
            >
              <h3 class="title font-weight-light text-xs-center grow">
                {{ name }}
              </h3>
            </v-card-title>
            <v-parallax
              :src="require(`../assets/${imageName}.jpg`)"
              height="250"
            ></v-parallax>
            <v-card-text :class="`pa-2 blue-grey darken-${hover ? 3 : 4}`">
              {{ info }}
            </v-card-text>
          </v-card>
        </v-hover>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<style scoped>
#particles-js {
  position: fixed;
  top: 44px;
  left: 0;
  width: 100%;
  height: 80%;
}
</style>

<script>
import isMobile from "mobile-device-detect";

const dateSlot = isMobile.isMobile ? "" : "opposite";

export default {
  name: "events",
  components: {},
  methods: {
    goUrl: function (event, link) {
      if (link) {
        const win = window.open(link, "_blank", "modal=no");
        win.focus();
      }
    },
  },
  data() {
    return {
      mobileDetected: isMobile.isMobile,
      dateSlot: dateSlot,
      hover: 2,
      pageEvents: [
        {
          name: "Goths on a Field",
          date: "10th July 2026",
          link: "https://www.tickettailor.com/events/gothsonabus/2007699",
          about: "blurb",
          imageName: "goaf",
          linkIcon: "event",
          info: "Headline act at Goths on a Field Festival",
        },
        {
          name: "The Sweet Kill",
          date: "22nd July 2026",
          link: "https://tickets-scotland.com/t5388",
          about: "blurb",
          imageName: "sweetkill",
          linkIcon: "event",
          info: "Glasgow with the Sweet Kill",
        },
        {
          name: "Deadinburgh",
          date: "4th July 2025",
          link: "https://www.skiddle.com/whats-on/Edinburgh/The-Hive/The-Deadinburgh-Festival-2025/40249598/",
          about: "blurb",
          imageName: "deadinburgh3",
          linkIcon: "event",
          info: "Edinburgh - Deadinburgh Festival",
        },
        {
          name: "Leodis requiem",
          date: "12th to 14th July 2023",
          link: "https://www.leodisrequiem.com/",
          about: "blurb",
          imageName: "logo",
          linkIcon: "event",
          info: "Headline act at Leodis Requiem, Leeds.",
        },
        {
          name: "Fields of the Nephilim",
          date: "12th Dec - 2022",
          link: "https://www.youtube.com/watch?v=kbG-gZlXdoU",
          about: "blurb",
          imageName: "fotn",
          linkIcon: "music_video",
          info: "Main Support for Fields of the Nephilim at O2 Academy Edinburgh.",
        },
        {
          name: "Birthday Massacre Tour",
          date: "31st Oct - 12th Nov 2022",
          link: "https://www.songkick.com/users/W.O.T.V",
          about: "blurb",
          imageName: "bm",
          linkIcon: "commute",
          info: "UK Tour with The Birthday Massacre - London, York, NewCastle, Edinburgh, Glasgow, Manchester, Wolverhampton, Nottingham, Bristol.",
        },
        {
          name: "Goth City Leeds",
          date: "9th July 2022",
          link: "http://www.gothcity.co.uk/",
          about: "blurb",
          imageName: "gothCity",
          linkIcon: "commute",
          info: "WotV Headline the Wharf Chambers stage on the Sat night at Goth City Leeds",
        },
        {
          name: "Sidewalks and Skeletons Massacre Tour",
          date: "31st Oct - 12th Nov 2022",
          link: "https://sidewalksandskeletons.com/uk-im-doing-a-mini-tour-next-month/",
          about: "blurb",
          imageName: "sidewalks",
          linkIcon: "commute",
          info: "UK mini-tour with The Sidewalks and Skeletons - Manchester, Glasgow, London, and Bristol.",
        },
        {
          name: "Baphomet Movie Soundtrack",
          date: "8th Jun - 2021",
          link: "https://cleorecs.com/store/shop/baphomet-dvd-or-blu-ray/",
          about: "blurb",
          imageName: "baphomet",
          linkIcon: "music_video",
          info: `WotV's feature in the Baphomet official movie soundtrack.`,
        },
        {
          name: "Scavenger Movie Soundtrack",
          date: "11th May 2021",
          link: "https://www.youtube.com/watch?v=aNZQLC77KuI",
          about: "blurb",
          imageName: "scavenger",
          linkIcon: "music_video",
          info: `WotV's first feature in an official movie soundtrack`,
        },
        {
          name: "Commemorate Album Release",
          date: "10th Dec 2020",
          link: "https://witchofthevale.bandcamp.com/album/commemorate-2",
          about: "blurb",
          imageName: "commemorate",
          linkIcon: "shopping_cart",
          info: "Witch of the Vales release of their debut album Commemorate.",
        },
        {
          name: "Boys of Summer",
          date: "19th Jun 2020",
          link: "https://witchofthevale.bandcamp.com/album/boys-of-summer",
          about: "blurb",
          imageName: "boys_of_summer",
          linkIcon: "shopping_cart",
          info: "WotV sign up with Cleopatra Records and release their first single with them.",
        },
        {
          name: "Unplugged",
          date: "24th May 2020",
          link: "https://www.youtube.com/watch?v=XBRoxPuojlY",
          about: "blurb",
          imageName: "livestream-small",
          linkIcon: "music_video",
          info: "First live stream performance. An unplugged session streamed from home.",
        },
        {
          name: "Linea Aspera",
          date: "10 - 11th Jan  2020",
          link: "https://www.facebook.com/events/459896214866233/",
          about: "blurb",
          imageName: "lineaaspera",
          linkIcon: "event",
          info: " Glasgow and sold out London show with Linea Aspera reunion tour",
        },
        {
          name: "Infest 2019",
          date: "24th Aug 2019",
          link: "https://infestuk.com/2019/02/15/infest-2019-witch-of-the-vale-confirmed/",
          about: "blurb",
          imageName: "witchinfest",
          linkIcon: "event",
          info: "Witch of the Vale - debut festival appearance at Infest UK",
        },
        {
          name: "Beat Cancer Manchester",
          date: "27th July 2019",
          about: "blurb",
          imageName: "bcmanchester",
          link: "https://www.facebook.com/events/aatma/bc-manchester-zeitgeist-zero-autoclav11-sidewalks-skeletons/310480666274582/",
          linkIcon: "event",
          info: "Beat:Cancer returns, with a very special gig and clubnight hosted by AnalogueTrash.",
        },
        {
          name: "Actors and Empathy Test",
          date: "21st June 2019",
          about: "blurb",
          imageName: "new-blood",
          link: "https://www.facebook.com/events/306254116716413/",
          linkIcon: "event",
          info: "Edinburgh Voodoo Rooms - supporting Actors and Empathy test on their New Blood Tour.",
        },
        {
          name: "Zanias and Buzzkull",
          date: "15th June 2019",
          about: "blurb",
          imageName: "zaniasLon",
          link: "https://www.facebook.com/events/2274798812775592/",
          linkIcon: "event",
          info: "London Electrowerkz - with Zanias and Buzzkull in Londons iconic Electrowerkz.",
        },
        {
          name: "She Past Away + Drab Majesty ",
          date: "8th June 2019",
          about: "blurb",
          imageName: "drab-past",
          link: "https://www.seetickets.com/event/drab-majesty-she-past-away-glasgow/audio/1334751",
          linkIcon: "receipt",
          info: "Glasgow - Audio,  supporting the iconic acts - She Past Away and Drab Majesty.",
        },
        {
          name: "Manchester with Ash Code",
          date: "15th Mar 2019",
          link: "https://witchofthevale.bandcamp.com/merch/live-show-manchester-15th-march-night-people-with-ash-code",
          about: "blurb",
          imageName: "banner",
          linkIcon: "receipt",
          info: "The second of two up-and-coming shows with Italian Dark Wave band Ash Code",
        },
        {
          name: "Glasgow with Ash Code",
          date: "14th Mar 2019",
          link: "https://witchofthevale.bandcamp.com/merch/live-show-glasgow-14th-march-ivory-blacks-with-ash-code",
          about: "blurb",
          imageName: "ashcode",
          linkIcon: "receipt",
          info: "The first of two up-and-coming shows with Italian Dark Wave band Ash Code",
        },
        {
          name: "Trust the Pain - EP Release",
          date: "8th Feb 2019",
          link: "https://witchofthevale.bandcamp.com/album/trust-the-pain",
          imageName: "ep2",
          linkIcon: "shopping_cart",
          info: "The second EP release by Witch of the Vale",
        },
        {
          name: "First play on BBC radio",
          date: "12th Jan 2019",
          link: "https://www.bbc.co.uk/programmes/p06vy9v0",
          about:
            "Witch of the Vale debuts on broadcast radio featuring on BBC Tees with Bob Fischer.",
          imageName: "introducing",
          linkIcon: "radio",
          info: "Witch of the Vale 's first appearance on national radio, featured on Introducting BBC Radio Tees with Bob Fischer",
        },
        {
          name: "Glasgow with Leaether Strip",
          date: "1st Sep 2018",
          link: "https://www.facebook.com/profile.php?id=100004525038512&sk=photos&collection_token=100004525038512%3A2305272732%3A69&set=a.1079120748915416&type=3",
          imageName: "leaetherStripSmall",
          linkIcon: "image_search",
          info: "Witch of the Vale joined the bill supporting Danish Industrial/EBM master Leaether Strip, with London based Mechanical Cabaret and Kuro.",
        },
        {
          name: "London with Solar Fake",
          date: "20th Oct 2018",
          link: "https://www.facebook.com/events/electrowerkz/solar-fake-massive-ego-witch-of-the-vale-auger/166208190852022/",
          imageName: "solarFakeSmall",
          linkIcon: "event",
          info: "Witch of the Vale supported German duo Solar Fake’s one-off UK show at Electrowerkz, London, alongside ‘dark-electro-pop’ band Massive Ego, and Industrial-Metal duo Auger.",
        },
        {
          name: "The Way This Will End - EP Release",
          date: "19th Oct 2018",
          link: "https://witchofthevale.bandcamp.com/music",
          imageName: "ep",
          linkIcon: "shopping_cart",
          info: "The duo independently released their first EP ‘The Way This Will End’ in October 2018. ",
        },
        {
          name: "London with Assemblage 23",
          date: "9th Sep 2018",
          link: "http://www.electricityclub.co.uk/assemblage-23-rainland-witch-of-the-vale-live-in-london/",
          imageName: "zaniasLon",
          linkIcon: "rate_review",
          info: "Witch of the Vale’s second show supporting Assemblage 23 at Electrowerkz, London, alongside fellow Scotsmen Rainland.  ",
        },
        {
          name: "Glasgow with Assemblage 23",
          date: "6th Sep 2018",
          link: "https://www.instagram.com/p/BnZcgahlBvB/?fbclid=IwAR1SX1CAQbRkwcYqfr98P73YgxD0JvDNEwr57QMEGW4as3UBXDsvUG9SGg0",
          imageName: "logo",
          linkIcon: "rate_review",
          info: "Witch of the Vale supporting Assemblage 23 on the first of two shows of their 2018 UK tour. Glasgow acts Rainland and Carnival also supported Tom Shear’s influential electronic act.",
        },
        {
          name: "Glasgow with Clan of Xymox",
          date: "30th June 2018",
          link: "https://www.flickr.com/photos/matrix_photography/albums/72157695445264770/with/30784538468/",
          imageName: "xymoxGlas",
          linkIcon: "image_search",
          info: "Witch of the Vale’s first live show, supporting darkwave legends Clan of Xymox. The support acts boasted a diverse mix of electronic styles from Rainland’s synthpop vibes, Kuro’s EBM undertones, and WotV bringing pagan drones and piano melodies.",
        },
      ],
    };
  },
};
</script>
